import React from 'react';
import { FadeIn } from '../ui/FadeIn';
export function TruthSection() {
  return <section className="py-32 px-6 bg-[#0a0a0a] relative overflow-hidden" data-id="element-111">
      {/* Abstract background element */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-full max-w-7xl pointer-events-none" data-id="element-112">
        <div className="absolute top-1/4 right-0 w-96 h-96 bg-blue-900/10 blur-[100px] rounded-full" data-id="element-113" />
      </div>

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-114">
        <FadeIn data-id="element-115">
          <span className="inline-block px-4 py-1 mb-6 text-sm font-bold tracking-widest text-blue-500 uppercase border border-blue-900/50 bg-blue-900/10 rounded-full" data-id="element-116">
            La verdad incómoda
          </span>
        </FadeIn>

        <FadeIn delay={0.1} data-id="element-117">
          <h2 className="text-4xl md:text-6xl font-black text-white mb-16 leading-tight tracking-tighter" data-id="element-118">
            LA DISCIPLINA NO SE "SIENTE".
            <br data-id="element-119" />
            LA DISCIPLINA SE <span className="text-blue-600" data-id="element-120">DISEÑA</span>.
          </h2>
        </FadeIn>

        <div className="grid md:grid-cols-2 gap-12 text-left" data-id="element-121">
          <FadeIn delay={0.2} className="bg-[#111] p-8 border-l-2 border-white/20" data-id="element-122">
            <p className="text-xl text-gray-300 leading-relaxed" data-id="element-123">
              Tu cerebro cansado no va a elegir lo difícil.{' '}
              <strong className="text-white" data-id="element-124">Va a elegir lo inmediato.</strong>
            </p>
          </FadeIn>

          <FadeIn delay={0.3} className="bg-[#111] p-8 border-l-2 border-blue-600" data-id="element-125">
            <p className="text-xl text-gray-300 leading-relaxed" data-id="element-126">
              Entonces el juego no es "ser más fuerte". El juego es que la
              distracción sea más difícil…{' '}
              <strong className="text-white" data-id="element-127">
                y lo importante sea más fácil.
              </strong>
            </p>
          </FadeIn>
        </div>

        <FadeIn delay={0.4} className="mt-16" data-id="element-128">
          <p className="text-2xl font-bold text-white" data-id="element-129">
            Eso es lo que hace <span className="text-blue-500" data-id="element-130">LOCK IN</span>.
          </p>
        </FadeIn>
      </div>
    </section>;
}